<div [matMenuTriggerFor]="values" matRipple>
  <span>{{value}}</span>
  <span style="flex: 1 1 auto"></span>
  <mat-icon>keyboard_arrow_down</mat-icon>
</div>
<mat-menu #values="matMenu">
  <ng-content></ng-content>
</mat-menu>
